import { Component } from '@angular/core';
import { ModalController, ViewController, Events, NavParams } from 'ionic-angular';
import { RepositoryMyRadiant, UserMyRadiant, HelperMyRadiant } from '../../providers';

/**
 * Generated class for the cmpFilterKaryawan component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'cmp-departmentList',
  templateUrl: 'cmp.html'
})
export class cmpDepartmentList {

  text: string;
  departmentActive : string = 'me';
  loading : any;
  data= {
    list:[],
    struktur_organisasi:[],
    title:"",
    selected: [],
  };
  count_expand = 0;
  level_parent = 1;
  
  parameter = {
    keyword:'',
    
  };
  searching = this.navParams.get('fiturSearching') || false;
  constructor(
    public viewCtrl   : ViewController,
    public events     : Events,
    public navParams  : NavParams, 
    public repositoryMyRadiant : RepositoryMyRadiant,
    public userApi : UserMyRadiant,
    public helper : HelperMyRadiant, 
  ) {
    let lastClick = localStorage.getItem('presensi_karyawan_attendance');
    if (lastClick != undefined) {
      this.departmentActive = localStorage.getItem('presensi_karyawan_attendance');
    }

    //check sebelumnya di select atau tidak
    let selected = this.navParams.get('departmentSelected');
    this.data.selected = selected;
    let newData = [];

    this.navParams.get('department').forEach(row => {
      let check_selected = this.helper.findValueFromArrayObject(selected,'id',row.id);
      if (check_selected !== -1) {
        row['selected'] = true;
      }else{
        row['selected'] = false;
      }
      newData.push(row);
    });

    this.data.list = newData;
    this.data.title = this.navParams.get('title');
  }

  tutup(){
    this.viewCtrl.dismiss(false); 
  }

  finish(){
    this.viewCtrl.dismiss(this.data.selected);
  }


  onSelectDepartment(evt,item,index){
    let check_selected = this.helper.findValueFromArrayObject(this.data.selected,'id',item.id);
    if (check_selected !== -1) {
      this.data.list[index]['selected'] = false;
      this.data.selected.splice(check_selected,1);
    }else{
      //belum diselect
      this.data.list[index]['selected'] = true;
      this.data.selected.push(item);
    }
  }
  onSearch(){
    if (this.parameter.keyword.length == 0) {
      this.data.list = this.navParams.get('department');
    }else{
      let res = this.helper.searchArrayByValueFromArrayObject(this.navParams.get('department'),this.parameter.keyword,'name'); 
      let data = [];
      res.forEach(row => {
        data.push(row);
      });
      this.data.list = data;
    }
  }
  getDataTree(params,callback) {  
    params.active_tab = localStorage.getItem('tabActiveProfile');  
    let maskLoading = this.helper.showLoading('Memuat...');
    this.repositoryMyRadiant.getBawahanFromTree(params).subscribe((resp:any) => {
      if (callback) {
        callback(resp.data.list);
      }
      setTimeout(() => {
        maskLoading.dismiss();        
      }, 500);  
    });
    //get tree 
  }
  onExpand(node) {
    let me = this;    
    me.count_expand += 1;
    let index = this.findIndexTree(me.data.struktur_organisasi,node.level,node.NODE_ID,me.level_parent-1);    
    if (index !== -1) {        
      if (!("Children" in index))
      {
        this.getDataTree(node,function(result) {                                       
            result.forEach(function(row,i) {
              result[i].TEXT = row.TEXT;
              result[i].state = 'opened';
              result[i].checked = node.checked;
            });
            index.Children = result;
           
        });
      }
    } 
    // this.pencarian.setData("data_unit_orgnisasi",me.data_tree);
  }

  findIndexTree(data,level,node_id,index) {
    let me = this,
        dt = data;
      if (level != index) {
        let idnode = node_id.split(".", index+1).join().replace(/,/g, '.')+'.';
        // index = level -1 ;
      let idx = me.helper.findValueFromArrayObject(data,"NODE_ID",idnode);   
      // console.log("data",data,"id_node",idx);         	
      if (idx !== -1) {        
        dt = data[idx];                
        // console.log("dt",dt);    
        if ("Children" in dt) {          
          // console.log("have children");
          dt = me.findIndexTree(dt.Children,level,node_id,index+1);
        }
      }
    }        
    return dt;
  }

}



// WEBPACK FOOTER //
// ./src/components/departmentList/cmp.ts